"use strict";
// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var SearchOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 24 24", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "clip-rule": "evenodd", "d": "M16.62 18.03a9 9 0 111.41-1.41l3.68 3.67a1 1 0 01-1.42 1.42l-3.67-3.68zM4 11a7 7 0 1114 0 7 7 0 01-14 0z", "fill-rule": "evenodd" } }] }, "name": "search", "theme": "outlined" };
exports.default = SearchOutlined;
